import { render, staticRenderFns } from "./LanguageMenu.vue?vue&type=template&id=0331d462&scoped=true"
import script from "./LanguageMenu.vue?vue&type=script&lang=js"
export * from "./LanguageMenu.vue?vue&type=script&lang=js"
import style0 from "./LanguageMenu.vue?vue&type=style&index=0&id=0331d462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0331d462",
  null
  
)

export default component.exports